// src/productsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";

export const fetchApprovedPlan = createAsyncThunk(
  "plan/approvedPlan",
  async ({ page=1, limit=10, search }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get("/approved-plans-admin", {
        params: { page, limit, search },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.data || response.status !== 200) {
        throw new Error("Failed to fetch plans");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "An error occurred while fetching plans"
      );
    }
  }
);

const approvedPlanSlice = createSlice({
  name: "plan",
  initialState: {
    items: [],
    totalItems: 0,
    status: "idle",
    error: null,
    loading: false,
    totalPlansAll:0 ,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApprovedPlan.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchApprovedPlan.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload.plans;
        state.totalItems = action.payload.totalPlans; // Assuming the total count is in the payload
        state.totalPlansAll = action.payload.allTotal ;
        state.loading = false;
      })
      .addCase(fetchApprovedPlan.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

export default approvedPlanSlice.reducer;
